import SkeletonBlock from '@loaders/SkeletonBlock';
import OnboardingPageLayout from '@modules/merchant/authentication/components/OnboardingPageLayout';
import { memo } from 'react';

const SearchBusinessPageSkeleton = memo(() => (
  <OnboardingPageLayout>
    <div className="flex w-full flex-col gap-form" aria-busy="true" aria-label="Loading search">
      <SkeletonBlock className="h-11 w-44 rounded-full" />

      <div className="flex w-full flex-col gap-0.75 desktop:gap-1">
        <SkeletonBlock className="skeleton-title w-72" />
        <SkeletonBlock className="skeleton-line h-6 w-80 max-w-full" />
      </div>

      <SkeletonBlock className="h-12 w-full rounded-field" />
      <SkeletonBlock className="h-[132px] w-full rounded md:h-[165px] md:rounded-[6px] desktop:h-[220px] desktop:rounded-lg" />
    </div>
  </OnboardingPageLayout>
));

SearchBusinessPageSkeleton.displayName = 'SearchBusinessPageSkeleton';

export default SearchBusinessPageSkeleton;
